<div
  *ngIf="
    booking.additionalQuestionData?.studiesDetails
      ?.universityTerm ||
    booking.additionalQuestionData?.finalGrade
  "
  class="row"
>
  <div
    *ngIf="booking.additionalQuestionData?.studiesDetails?.universityTerm"
    class="col-12 col-lg-6"
  >
    <p>
      <strong>
        {{
        'booking.sdv.additional-questions-page.studiesDetails.term.question'
          | translate
        }}
      </strong>
    </p>
    <p>
      {{
      booking.additionalQuestionData?.studiesDetails?.universityTerm
      }}
    </p>
  </div>

  <div
    *ngIf="booking.additionalQuestionData?.finalGrade"
    class="col-12 col-lg-6"
  >
    <p>
      <strong>
        {{
          'booking.sdv.additional-questions-page.studentDetails.finalGrade'
            | translate
        }}
      </strong>
    </p>
    <p>
      {{ booking.additionalQuestionData?.finalGrade }}
    </p>
  </div>
</div>

<div
  *ngIf="
    booking.additionalQuestionData?.studentDetails
      ?.schoolSubjects?.german?.grade ||
    booking.additionalQuestionData?.studentDetails
      ?.schoolSubjects?.german?.points ||
    booking.additionalQuestionData?.studentDetails
      ?.schoolSubjects?.mathematics?.grade ||
    booking.additionalQuestionData?.studentDetails
      ?.schoolSubjects?.mathematics?.points
  "
  class="row"
>
  <div
    *ngIf="
    booking.additionalQuestionData?.studentDetails
      ?.schoolSubjects?.german?.grade ||
    booking.additionalQuestionData?.studentDetails
      ?.schoolSubjects?.german?.points
  "
    class="col-12 col-lg-6"
  >
    <p>
      <strong>
        {{
        'booking.sdv.additional-questions-page.studentDetails.schoolSubjects.german'
          | translate
        }}
      </strong>
    </p>

    <div class="row">
      <div
        *ngIf="
        booking.additionalQuestionData?.studentDetails
          ?.schoolSubjects?.german?.grade
      "
        class="col-6"
      >
        <p>
          <span>
            {{
            'booking.sdv.additional-questions-page.studentDetails.schoolSubjects.label.grade'
              | translate
            }}:
          </span>
          <span>
            {{ booking.additionalQuestionData?.studentDetails?.schoolSubjects?.german?.grade }}
          </span>
        </p>
      </div>

      <div
        *ngIf="
        booking.additionalQuestionData?.studentDetails
          ?.schoolSubjects?.german?.points
      "
        class="col-6"
      >
        <p>
          <span>
            {{
            'booking.sdv.additional-questions-page.studentDetails.schoolSubjects.label.points'
              | translate
            }}:
          </span>
          <span>
            {{ booking.additionalQuestionData?.studentDetails?.schoolSubjects?.german?.points }}
          </span>
        </p>
      </div>
    </div>
  </div>

  <div
    *ngIf="
    booking.additionalQuestionData?.studentDetails
      ?.schoolSubjects?.mathematics?.grade ||
    booking.additionalQuestionData?.studentDetails
      ?.schoolSubjects?.mathematics?.points
  "
    class="col-12 col-lg-6"
  >
    <p>
      <strong>
        {{
        'booking.sdv.additional-questions-page.studentDetails.schoolSubjects.mathematics'
          | translate
        }}
      </strong>
    </p>

    <div
      class="row"
    >
      <div
        *ngIf="
        booking.additionalQuestionData?.studentDetails
          ?.schoolSubjects?.mathematics?.grade
      "
        class="col-6"
      >
        <p>
          <span>
            {{
            'booking.sdv.additional-questions-page.studentDetails.schoolSubjects.label.grade'
              | translate
            }}:
          </span>
          <span>
            {{ booking.additionalQuestionData?.studentDetails?.schoolSubjects?.mathematics?.grade }}
          </span>
        </p>
      </div>

      <div
        *ngIf="
        booking.additionalQuestionData?.studentDetails
          ?.schoolSubjects?.mathematics?.points
      "
        class="col-6"
      >
      <p>
        <span>
          {{
          'booking.sdv.additional-questions-page.studentDetails.schoolSubjects.label.points'
            | translate
          }}:
        </span>
        <span>
          {{ booking.additionalQuestionData?.studentDetails?.schoolSubjects?.mathematics?.points }}
        </span>
      </p>
      </div>
    </div>
  </div>

</div>

<div class="row">
  <div
    *ngIf="
      booking.additionalQuestionData?.studentDetails
        ?.germanLanguageLevel
    "
    class="col-12 col-lg-6"
  >
    <p>
      <strong>
        {{
          'booking.sdv.additional-questions-page.studentDetails.germanLanguageLevel.question'
            | translate
        }}
      </strong>
    </p>
    <p>
      {{ getLanguageLevelLabel | translate }}
    </p>
  </div>

  <div
    *ngIf="
      booking.additionalQuestionData?.studentDetails
        ?.migrationBackground !== undefined
    "
    class="col-12 col-lg-6"
  >
    <p>
      <strong>
        {{
          'booking.sdv.additional-questions-page.studentDetails.migrationBackground.question'
            | translate
        }}
      </strong>
    </p>
    <p>
      {{
        booking.additionalQuestionData?.studentDetails
          ?.migrationBackground
          ? ('booking.sdv.additional-questions-page.studentDetails.migrationBackground.options.yes'
            | translate)
          : ('booking.sdv.additional-questions-page.studentDetails.migrationBackground.options.no'
            | translate)
      }}
    </p>
  </div>
</div>
